/**
 * reverse.pipe.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { IterableDiffer, IterableDiffers, Pipe } from "@angular/core";

@Pipe({
  name: "reverse",
  pure: false
})
export class ReversePipe {
    private differ : IterableDiffer;
    private cached : any[];

    constructor (differs : IterableDiffers)
    {
        // This creates a local differ from the global differ factory registry
        this.differ = differs.find([]).create(null);
    }

    public transform (value : Iterable<any>) : any[]
    {
        // Using the differ allows us to lean on Angular's change detection for
        // better performance, which is important in an impure pipe.
        const changes : any = this.differ.diff(value);
        if (changes)
        {
            // NOTE: We're allowing generic Iterable inputs, so we can't use
            // Array.prototype.slice to clone here (hence the Array.from)
            this.cached = Array.from(value).reverse();
        }
        return this.cached;
    }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/support/pipes/reverse.pipe.ts